import { Accordion, Card } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import conf from 'conf/conf';
import { isPlCountry } from '../helper/tariffHelper';

const FAQ_KEYS = ['q1', 'q2', 'q3', 'q4', 'q5', 'q6', 'q7'] as const;
const PL_FAQ_KEYS = new Set(['q1', 'q2', 'q3']);

const TariffFAQ = () => {
    const { t } = useTranslation('TariffFAQ');
    const telegramHandle = String(conf.tariffTelegram || '@e_landing');
    const telegramUrl = `https://t.me/${telegramHandle.replace(/^@/, '')}`;
    const isPl = isPlCountry();

    const itemPath = (key: typeof FAQ_KEYS[number]) => (
        isPl && PL_FAQ_KEYS.has(key) ? `itemsPl.${key}` : `items.${key}`
    );

    const renderAnswer = (key: typeof FAQ_KEYS[number]) => {
        const path = itemPath(key);
        const answer = t(`${path}.answer`, { defaultValue: '' });

        if (answer) {
            return <p className="text-muted f-12 mb-0">{answer}</p>;
        }

        return (
            <p className="text-muted f-12 mb-0">
                {t(`${path}.answerBefore`)}{' '}
                <a
                    href={telegramUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="fw-medium"
                >
                    {telegramHandle}
                </a>
                {t(`${path}.answerAfter`)}
            </p>
        );
    };

    return (
        <Card className="mt-4">
            <Card.Body>
                <h5 className="mb-3 fw-bold">{t('title')}</h5>
                <Accordion flush>
                    {FAQ_KEYS.map((key) => (
                        <Accordion.Item eventKey={key} key={key}>
                            <Accordion.Header className="fs-12 fw-medium">
                                {t(`${itemPath(key)}.question`)}
                            </Accordion.Header>
                            <Accordion.Body>
                                {renderAnswer(key)}
                            </Accordion.Body>
                        </Accordion.Item>
                    ))}
                </Accordion>
            </Card.Body>
        </Card>
    );
};

export default TariffFAQ;
